/* script */
//
//
//

  /*
    This is a modified version of this https://github.com/MartyWallace/vue-keyboard
  */
  import Icon from "../common/Icon.vue";
	const Tokens = {
		// Sequences that no-one will ever put in their keyboards.
		PIPE: '7440011c983cf39ae730b1f831e2922ac5a76910',
		OPEN_BRACE: 'f630c4abcae620278f82e142a526ef325c2a773a',
		CLOSE_BRACE: 'ad982c66898e02a5dab419ea7568421b03f68ee2',
	};

	const __vue_script__ = {
		name: 'Keyboard',

		components: {
      Icon,
		},
		
		props: {
			value: {
				type: String,
				default: '',
			},
			layouts: {
				type: [String, Array],
				required: true,
			},
			maxlength: {
				type: Number,
				default: 0,
				validator: value => value >= 0,
			},
			pattern: {
				type: String,
				default: null,
			},
    },
    
		data() {
			return {
				layout: 0,
			};
		},

		computed: {
			/**
			 * Whether or not the keyboard input has hit its maximum length.
			 * @returns {Boolean}
			 */
			full() {
				return this.maxlength > 0 && this.value.length >= this.maxlength;
			},

			/**
			 * Whether or not the keyboard input is empty.
			 * @return {Boolean}
			 */
			empty() {
				return this.value.length === 0;
			},

			/**
			 * Returns the lines that make up a layout.
			 * @return {Array}
			 */
			lines() {
				let layout = (Array.isArray(this.layouts) ? this.layouts : [this.layouts])[this.layout];

				return layout.replace('||', Tokens.PIPE)
					.replace('{{', Tokens.OPEN_BRACE)
					.replace('}}', Tokens.CLOSE_BRACE)
					.split('|');
			},

			/**
			 * Returns an array of buttons to render in the component.
			 * @returns {Array[]}
			 */
			buttons() {
				return this.lines.map(line => {
					// TODO: Could potentially rely on Object.values() here instead of being explicit.
					let stream = line.match(new RegExp(`(${Tokens.OPEN_BRACE}|${Tokens.CLOSE_BRACE}|${Tokens.PIPE}|.)`, 'g'));

					let buttons = [];
					let token = null;

					stream.forEach(char => {
						if (char === '{') {
							token = '';
						} else if (char === '}') {
							let command = token.split(':');
							let text = command.length > 1 ? command[0] : '';
							let action = command.length > 1 ? command[1] : command[0];
							let args = command.length > 2 ? command[2] : null;
							let method = null;

							if (['append', 'backspace', 'space', 'clear', 'goto'].indexOf(action) >= 0) method = this[action].bind(this, args);
							else method = this.$emit.bind(this, action, this);

							buttons.push({
								type: 'action',
								action: { name: action.replace(/\s+/g, '-').toLowerCase(), callable: method },
								value: text,
								args,
							});
							
							token = null;
						} else {
							if (token !== null) {
								token += char;
							} else {
								if (char === Tokens.PIPE) char = '|';
								if (char === Tokens.OPEN_BRACE) char = '{';
								if (char === Tokens.CLOSE_BRACE) char = '}';

								buttons.push({
									type: 'char',
									action: { name: null, callable: this.append.bind(this, char) },
									value: char,
									args: null,
								});
							}
						}
					});

					return buttons;
				});
			},

			/**
			 * Whether or not the current value matches the regex provided to pattern. Always
			 * returns true if no pattern was provided.
			 * @returns {Boolean}
			 */
			valid() {
				return !this.pattern || this.value.match(new RegExp(this.pattern));
			},
		},

		methods: {
			/**
			 * Mutates the keyboard value to a new value.
			 * @param {String} value The new value.
			 */
			mutate(value) {
				if (this.maxlength > 0) {
					value = value.slice(0, this.maxlength);
				}

				this.$emit('input', value);
			},

			/**
			 * Appends a new value to the end of the current keyboard value.
			 * @param {String} char The character(s) to append.
			 */
			append(char) {
				this.mutate(this.value + char);
			},

			/**
			 * Remove the last character from the current keyboard value.
			 */
			backspace() {
				this.mutate(this.value.slice(0, this.value.length - 1));
			},

			/**
			 * Add one whitespace character to the current keyboard value.
			 */
			space() {
				this.append(' ');
			},

			/**
			 * Go to a new layout.
			 * @param {Number} The layout index.
			 */
			goto(layout) {
				if (Array.isArray(this.layouts)) {
					if (layout >= 0 && layout < this.layouts.length) {
						this.layout = layout;
					} else {
						throw new Error('The requested layout does not exist.');
					}
				} else {
					throw new Error('A single non-array layout was provided.');
				}
			},

			/**
			 * Clear the entire keyboard value.
			 */
			clear() {
				this.mutate('');
			},
		},
	};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "aside",
    {
      staticClass: "vue-keyboard",
      class: {
        full: _vm.full,
        empty: _vm.empty,
        valid: _vm.valid,
        invalid: !_vm.valid,
      },
      attrs: {
        role: "application",
        "data-value": _vm.value,
        "data-layout": _vm.layout,
      },
    },
    _vm._l(_vm.buttons, function (row, index) {
      return _c(
        "div",
        {
          key: index,
          staticClass: "vue-keyboard-row",
          attrs: { role: "row", "data-keys": "row.length" },
        },
        _vm._l(row, function (btn, index) {
          return _c(
            "button",
            {
              key: index,
              staticClass: "vue-keyboard-key",
              class: btn.type,
              attrs: {
                role: "button",
                "data-args": btn.args,
                "data-text": btn.value,
                "data-action": btn.action.name,
                tabindex: "-1",
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return btn.action.callable.apply(null, arguments)
                },
              },
            },
            [
              btn.action.name === "backspace"
                ? _c(
                    "div",
                    {
                      staticClass:
                        "vue-keboard-key-icon vue-keboard-key-icon-backspace",
                    },
                    [_c("Icon", { attrs: { "icon-name": "arrow-right" } })],
                    1
                  )
                : _c("span", { staticClass: "vue-keboard-key-text" }, [
                    _vm._v("\n        " + _vm._s(btn.value) + "\n      "),
                  ]),
            ]
          )
        }),
        0
      )
    }),
    0
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-76af6be6_0", { source: "\n.vue-keyboard-row {\n\ttext-align: center;\n}\n.vue-keyboard-key {\n\tborder: none;\n\toutline: none;\n\tcursor: pointer;\n}\n", map: {"version":3,"sources":["resources/kiosk/scripts/components/common/Keyboard.vue"],"names":[],"mappings":";AAyPA;CACA,kBAAA;AACA;AAEA;CACA,YAAA;CACA,aAAA;CACA,eAAA;AACA","file":"Keyboard.vue","sourcesContent":["\n\n\n<script>\n  /*\n    This is a modified version of this https://github.com/MartyWallace/vue-keyboard\n  */\n  import Icon from \"../common/Icon.vue\";\n\tconst Tokens = {\n\t\t// Sequences that no-one will ever put in their keyboards.\n\t\tPIPE: '7440011c983cf39ae730b1f831e2922ac5a76910',\n\t\tOPEN_BRACE: 'f630c4abcae620278f82e142a526ef325c2a773a',\n\t\tCLOSE_BRACE: 'ad982c66898e02a5dab419ea7568421b03f68ee2',\n\t};\n\n\texport default {\n\t\tname: 'Keyboard',\n\n\t\tcomponents: {\n      Icon,\n\t\t},\n\t\t\n\t\tprops: {\n\t\t\tvalue: {\n\t\t\t\ttype: String,\n\t\t\t\tdefault: '',\n\t\t\t},\n\t\t\tlayouts: {\n\t\t\t\ttype: [String, Array],\n\t\t\t\trequired: true,\n\t\t\t},\n\t\t\tmaxlength: {\n\t\t\t\ttype: Number,\n\t\t\t\tdefault: 0,\n\t\t\t\tvalidator: value => value >= 0,\n\t\t\t},\n\t\t\tpattern: {\n\t\t\t\ttype: String,\n\t\t\t\tdefault: null,\n\t\t\t},\n    },\n    \n\t\tdata() {\n\t\t\treturn {\n\t\t\t\tlayout: 0,\n\t\t\t};\n\t\t},\n\n\t\tcomputed: {\n\t\t\t/**\n\t\t\t * Whether or not the keyboard input has hit its maximum length.\n\t\t\t * @returns {Boolean}\n\t\t\t */\n\t\t\tfull() {\n\t\t\t\treturn this.maxlength > 0 && this.value.length >= this.maxlength;\n\t\t\t},\n\n\t\t\t/**\n\t\t\t * Whether or not the keyboard input is empty.\n\t\t\t * @return {Boolean}\n\t\t\t */\n\t\t\tempty() {\n\t\t\t\treturn this.value.length === 0;\n\t\t\t},\n\n\t\t\t/**\n\t\t\t * Returns the lines that make up a layout.\n\t\t\t * @return {Array}\n\t\t\t */\n\t\t\tlines() {\n\t\t\t\tlet layout = (Array.isArray(this.layouts) ? this.layouts : [this.layouts])[this.layout];\n\n\t\t\t\treturn layout.replace('||', Tokens.PIPE)\n\t\t\t\t\t.replace('{{', Tokens.OPEN_BRACE)\n\t\t\t\t\t.replace('}}', Tokens.CLOSE_BRACE)\n\t\t\t\t\t.split('|');\n\t\t\t},\n\n\t\t\t/**\n\t\t\t * Returns an array of buttons to render in the component.\n\t\t\t * @returns {Array[]}\n\t\t\t */\n\t\t\tbuttons() {\n\t\t\t\treturn this.lines.map(line => {\n\t\t\t\t\t// TODO: Could potentially rely on Object.values() here instead of being explicit.\n\t\t\t\t\tlet stream = line.match(new RegExp(`(${Tokens.OPEN_BRACE}|${Tokens.CLOSE_BRACE}|${Tokens.PIPE}|.)`, 'g'));\n\n\t\t\t\t\tlet buttons = [];\n\t\t\t\t\tlet token = null;\n\n\t\t\t\t\tstream.forEach(char => {\n\t\t\t\t\t\tif (char === '{') {\n\t\t\t\t\t\t\ttoken = '';\n\t\t\t\t\t\t} else if (char === '}') {\n\t\t\t\t\t\t\tlet command = token.split(':');\n\t\t\t\t\t\t\tlet text = command.length > 1 ? command[0] : '';\n\t\t\t\t\t\t\tlet action = command.length > 1 ? command[1] : command[0];\n\t\t\t\t\t\t\tlet args = command.length > 2 ? command[2] : null;\n\t\t\t\t\t\t\tlet method = null;\n\n\t\t\t\t\t\t\tif (['append', 'backspace', 'space', 'clear', 'goto'].indexOf(action) >= 0) method = this[action].bind(this, args);\n\t\t\t\t\t\t\telse method = this.$emit.bind(this, action, this);\n\n\t\t\t\t\t\t\tbuttons.push({\n\t\t\t\t\t\t\t\ttype: 'action',\n\t\t\t\t\t\t\t\taction: { name: action.replace(/\\s+/g, '-').toLowerCase(), callable: method },\n\t\t\t\t\t\t\t\tvalue: text,\n\t\t\t\t\t\t\t\targs,\n\t\t\t\t\t\t\t});\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\ttoken = null;\n\t\t\t\t\t\t} else {\n\t\t\t\t\t\t\tif (token !== null) {\n\t\t\t\t\t\t\t\ttoken += char;\n\t\t\t\t\t\t\t} else {\n\t\t\t\t\t\t\t\tif (char === Tokens.PIPE) char = '|';\n\t\t\t\t\t\t\t\tif (char === Tokens.OPEN_BRACE) char = '{';\n\t\t\t\t\t\t\t\tif (char === Tokens.CLOSE_BRACE) char = '}';\n\n\t\t\t\t\t\t\t\tbuttons.push({\n\t\t\t\t\t\t\t\t\ttype: 'char',\n\t\t\t\t\t\t\t\t\taction: { name: null, callable: this.append.bind(this, char) },\n\t\t\t\t\t\t\t\t\tvalue: char,\n\t\t\t\t\t\t\t\t\targs: null,\n\t\t\t\t\t\t\t\t});\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t});\n\n\t\t\t\t\treturn buttons;\n\t\t\t\t});\n\t\t\t},\n\n\t\t\t/**\n\t\t\t * Whether or not the current value matches the regex provided to pattern. Always\n\t\t\t * returns true if no pattern was provided.\n\t\t\t * @returns {Boolean}\n\t\t\t */\n\t\t\tvalid() {\n\t\t\t\treturn !this.pattern || this.value.match(new RegExp(this.pattern));\n\t\t\t},\n\t\t},\n\n\t\tmethods: {\n\t\t\t/**\n\t\t\t * Mutates the keyboard value to a new value.\n\t\t\t * @param {String} value The new value.\n\t\t\t */\n\t\t\tmutate(value) {\n\t\t\t\tif (this.maxlength > 0) {\n\t\t\t\t\tvalue = value.slice(0, this.maxlength);\n\t\t\t\t}\n\n\t\t\t\tthis.$emit('input', value);\n\t\t\t},\n\n\t\t\t/**\n\t\t\t * Appends a new value to the end of the current keyboard value.\n\t\t\t * @param {String} char The character(s) to append.\n\t\t\t */\n\t\t\tappend(char) {\n\t\t\t\tthis.mutate(this.value + char);\n\t\t\t},\n\n\t\t\t/**\n\t\t\t * Remove the last character from the current keyboard value.\n\t\t\t */\n\t\t\tbackspace() {\n\t\t\t\tthis.mutate(this.value.slice(0, this.value.length - 1));\n\t\t\t},\n\n\t\t\t/**\n\t\t\t * Add one whitespace character to the current keyboard value.\n\t\t\t */\n\t\t\tspace() {\n\t\t\t\tthis.append(' ');\n\t\t\t},\n\n\t\t\t/**\n\t\t\t * Go to a new layout.\n\t\t\t * @param {Number} The layout index.\n\t\t\t */\n\t\t\tgoto(layout) {\n\t\t\t\tif (Array.isArray(this.layouts)) {\n\t\t\t\t\tif (layout >= 0 && layout < this.layouts.length) {\n\t\t\t\t\t\tthis.layout = layout;\n\t\t\t\t\t} else {\n\t\t\t\t\t\tthrow new Error('The requested layout does not exist.');\n\t\t\t\t\t}\n\t\t\t\t} else {\n\t\t\t\t\tthrow new Error('A single non-array layout was provided.');\n\t\t\t\t}\n\t\t\t},\n\n\t\t\t/**\n\t\t\t * Clear the entire keyboard value.\n\t\t\t */\n\t\t\tclear() {\n\t\t\t\tthis.mutate('');\n\t\t\t},\n\t\t},\n\t};\n</script>\n\n<template>\n  <aside\n    class=\"vue-keyboard\"\n    role=\"application\"\n    :class=\"{ full: full, empty: empty, valid: valid, invalid: !valid }\"\n    :data-value=\"value\"\n    :data-layout=\"layout\"\n  >\n    <div\n      role=\"row\"\n      class=\"vue-keyboard-row\"\n      v-for=\"(row, index) in buttons\"\n      :key=\"index\"\n      data-keys=\"row.length\"\n    >\n      <button\n        v-for=\"(btn, index) in row\"\n        :key=\"index\"\n        class=\"vue-keyboard-key\"\n        role=\"button\"\n        :class=\"btn.type\"\n        :data-args=\"btn.args\"\n        :data-text=\"btn.value\"\n        :data-action=\"btn.action.name\"\n        tabindex=\"-1\"\n        @click.prevent=\"btn.action.callable\"\n      >\n        <div\n          class=\"vue-keboard-key-icon vue-keboard-key-icon-backspace\"\n          v-if=\"btn.action.name === 'backspace'\"\n        >\n          <Icon icon-name=\"arrow-right\"/>\n        </div>\n        <span\n          class=\"vue-keboard-key-text\"\n          v-else\n        >\n          {{ btn.value }}\n        </span>\n      </button>\n    </div>\n  </aside>\n</template>\n\n<style>\n\t.vue-keyboard-row {\n\t\ttext-align: center;\n\t}\n\n\t.vue-keyboard-key {\n\t\tborder: none;\n\t\toutline: none;\n\t\tcursor: pointer;\n\t}\n</style>"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "resources/kiosk/scripts/components/common/Keyboard.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__